import i18next from 'i18next';
import {initReactI18next} from 'react-i18next';

import {languageFromPath} from './detection';
import resources from './resources';

/** 初始语言由 URL 前缀唯一决定（无前缀 = 中文）；localStorage/navigator 不再参与（SEO：URL↔内容必须确定） */
const initialLanguage = languageFromPath(window.location.pathname) || 'zh-CN';

i18next.use(initReactI18next).init({
  fallbackLng: 'zh-CN',
  interpolation: {escapeValue: false}, // React 已做 XSS 转义，关闭 i18next 自带的 HTML 转义
  lng: initialLanguage,
  react: {useSuspense: false}, // 资源同步打包，无异步加载，测试环境也不需要 Suspense 边界
  resources,
  supportedLngs: ['en', 'zh-CN', 'ko', 'ru'],
});

/** 同步 <html lang>（无 SSR，JS 生效前的首屏由 public/index.html 的 zh-CN 兜底） */
export const applyDocumentLang = (language: string) => {
  if (typeof document !== 'undefined') document.documentElement.lang = language;
};
applyDocumentLang(initialLanguage);

export default i18next;
